/** Plugin Category types */
export const pluginCategories = ['main', 'music', 'social', 'learn', 'gear', 'other'] as const
export type PluginCategory = (typeof pluginCategories)[number]
